import { React } from '../../shared/react.js';
import { Icon } from '../../shared/icons.js';
import { ArtworkImage } from '../../shared/ui/ArtworkImage.js';
import { compareArtworks } from '../../app/app.selectors.js';
import { useAppRuntime, useAppState } from '../../app/app.context.js';

export function ComparePanel(props: { readonly onClose: () => void }) {
  const runtime = useAppRuntime();
  const state = useAppState();
  const artworks = compareArtworks(state);
  if (artworks.length < 2) return null;
  const [left, right] = artworks;
  if (!left || !right) return null;

  return (
    <section className="compare-panel" aria-label="Artwork comparison">
      <div className="compare-panel__heading">
        <strong>Compare</strong>
        <button type="button" className="icon-button" onClick={() => { runtime.clearCompare(); props.onClose(); }} aria-label="Close comparison"><Icon name="close" size={14}/></button>
      </div>
      <div className="compare-panel__cards">
        {[left, right].map((artwork) => (
          <button type="button" key={artwork.id} onClick={() => runtime.selectArtwork(artwork.id)}>
            <span><ArtworkImage src={artwork.thumbnailUrl ?? artwork.imageUrl} alt="" width={artwork.imageWidth} height={artwork.imageHeight} dominantColor={artwork.dominantColor}/></span>
            <strong>{artwork.title}</strong>
            <small>{artwork.objectDate || artwork.creator}</small>
          </button>
        ))}
      </div>
      <dl className="compare-panel__facts">
        <div><dt>Medium</dt><dd>{sharedOrDifferent(left.medium, right.medium)}</dd></div>
        <div><dt>Culture</dt><dd>{sharedOrDifferent(left.culture, right.culture)}</dd></div>
        <div><dt>Period</dt><dd>{sharedOrDifferent(left.period, right.period)}</dd></div>
      </dl>
    </section>
  );
}

function sharedOrDifferent(left: string, right: string): string {
  if (!left && !right) return 'Not recorded';
  if (left.trim().toLowerCase() === right.trim().toLowerCase()) return left || right;
  return 'Different';
}
